import { Switch, Match, For, Show } from "solid-js";
import { twMerge } from "tailwind-merge";

export function StarIcon(props) {
  const size = props.size ? props.size : 24;
  const state = props.state ? props.state : "EMPTY";

  return (
    <Switch
      fallback={
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height={size}
          viewBox="0 -960 960 960"
          width={size}
          data-meta="Star icon empty"
        >
          <path d="m354-247 126-76 126 77-33-144 111-96-146-13-58-136-58 135-146 13 111 97-33 143Zm-90.998 125.458 57.307-246.766L128.85-534.23l252.613-21.922L480-788.842l98.537 232.69L831.15-534.23 639.691-368.308l57.307 246.766L480-252.463 263.002-121.542ZM480-430Z" />
        </svg>
      }
    >
      <Match when={state === "FILLED"}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height={size}
          viewBox="0 -960 960 960"
          width={size}
          data-meta="Star icon filled"
        >
          <path d="m263.002-121.542 57.307-246.766L128.85-534.23l252.613-21.922L480-788.842l98.537 232.69L831.15-534.23 639.691-368.308l57.307 246.766L480-252.463 263.002-121.542Z" />
        </svg>
      </Match>
      <Match when={state === "HALF"}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height={size}
          viewBox="0 -960 960 960"
          width={size}
          data-meta="Star icon half"
        >
          <path d="M480-635v312l126 77-33-144 111-96-146-13-58-136ZM263.002-121.542l57.307-246.766L128.85-534.23l252.613-21.922L480-788.842l98.537 232.69L831.15-534.23 639.691-368.308l57.307 246.766L480-252.463 263.002-121.542Z" />
        </svg>
      </Match>
    </Switch>
  );
}

export const Stars = (props) => {
  const ratingIntPart = Math.floor(props.rating);
  const ratingDecPart = ratingIntPart - props.rating;
  const ceiledRating = Math.ceil(props.rating);
  const blankStars = 5 - ceiledRating;
  
  return (
    <span class={twMerge(
      "spr-starratings",
      props.class ?? ""
    )} style={props.style ?? ""} aria-label={`${props.rating} of 5 stars`} role="img">
      <For each={Array(isNaN(ratingIntPart) ? 0 : ratingIntPart).fill(0)}>{(i) => (
        <svg xmlns="http://www.w3.org/2000/svg" height="40" viewBox="0 -960 960 960" width="40" style={props.starStyle ?? ""} class={`${props.starClass ?? ''}`}>
          <path
            d="M480-229 300.666-121q-9 5.667-19 5-10-.666-17.666-6.333-7.667-5.667-11.667-14.5t-1.666-19.833L298-361 139.666-498.667q-8.666-7.667-10.5-17.167-1.833-9.499.834-18.499 2.666-9 10-15 7.333-6 18.666-7.334L368-575l81-192.667q4.333-10 13.167-15 8.833-5 17.833-5 9 0 17.833 5 8.834 5 13.167 15L592-575l209.334 18.333q11.333 1.334 18.666 7.334 7.334 6 10 15 2.667 9 .834 18.499-1.834 9.5-10.5 17.167L662-361l47.333 204.334q2.334 11-1.666 19.833-4 8.833-11.667 14.5-7.666 5.667-17.666 6.333-10 .667-19-5L480-229Z" />
        </svg>
      )}</For>
      <Show when={ratingDecPart != 0 && !isNaN(ratingDecPart)}>
        <svg xmlns="http://www.w3.org/2000/svg" height="40" viewBox="0 -960 960 960" width="40" style={props.starStyle ?? ""} class={`${props.starClass ?? ''}`}>
          <path
            d="M480-669.001V-307l146.667 89.001-39-166.668 129.001-112-170.001-15L480-669.001ZM480-229 300.666-121q-9 5.667-19 5-10-.666-17.666-6.333-7.667-5.667-11.667-14.5t-1.666-19.833L298-361 139.666-498.667q-8.666-7.667-10.5-17.167-1.833-9.499.834-18.499 2.666-9 10-15 7.333-6 18.666-7.334L368-575l81-192.667q4.333-10 13.167-15 8.833-5 17.833-5 9 0 17.833 5 8.834 5 13.167 15L592-575l209.334 18.333q11.333 1.334 18.666 7.334 7.334 6 10 15 2.667 9 .834 18.499-1.834 9.5-10.5 17.167L662-361l47.333 204.334q2.334 11-1.666 19.833-4 8.833-11.667 14.5-7.666 5.667-17.666 6.333-10 .667-19-5L480-229Z" />
        </svg>
      </Show>
      <For each={Array(isNaN(blankStars) ? 0 : blankStars).fill(0)}>{(i) => (
        <svg xmlns="http://www.w3.org/2000/svg" height="40" viewBox="0 -960 960 960" width="40" style={props.starStyle ?? ""} class={`${props.starClass ?? ''}`}>
          <path
            d="M333.333-218.999 480-307l146.667 89.001-39-166.668 129.001-112-170.001-15L480-669.001l-66.667 156.334-170.001 15 129.001 112.334-39 166.334ZM480-229 300.666-121q-9 5.667-19 5-10-.666-17.666-6.333-7.667-5.667-11.667-14.5t-1.666-19.833L298-361 139.666-498.667q-8.666-7.667-10.5-17.167-1.833-9.499.834-18.499 2.666-9 10-15 7.333-6 18.666-7.334L368-575l81-192.667q4.333-10 13.167-15 8.833-5 17.833-5 9 0 17.833 5 8.834 5 13.167 15L592-575l209.334 18.333q11.333 1.334 18.666 7.334 7.334 6 10 15 2.667 9 .834 18.499-1.834 9.5-10.5 17.167L662-361l47.333 204.334q2.334 11-1.666 19.833-4 8.833-11.667 14.5-7.666 5.667-17.666 6.333-10 .667-19-5L480-229Zm0-204.333Z" />
        </svg>
      )}</For>
    </span>
  )
}

export const Star = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 -960 960 960"
      width="40"
      height="40"
      stroke-width="48"
      stroke="currentColor"
      class={props.starClass ?? ""}
      classList={props.starClassList ?? {}}
      onClick={props.onClick}
      onmouseover={props.onMouseOver}
      onmouseout={props.onMouseOut}
    >
      <path
        d="M480-229 300.666-121q-9 5.667-19 5-10-.666-17.666-6.333-7.667-5.667-11.667-14.5t-1.666-19.833L298-361 139.666-498.667q-8.666-7.667-10.5-17.167-1.833-9.499.834-18.499 2.666-9 10-15 7.333-6 18.666-7.334L368-575l81-192.667q4.333-10 13.167-15 8.833-5 17.833-5 9 0 17.833 5 8.834 5 13.167 15L592-575l209.334 18.333q11.333 1.334 18.666 7.334 7.334 6 10 15 2.667 9 .834 18.499-1.834 9.5-10.5 17.167L662-361l47.333 204.334q2.334 11-1.666 19.833-4 8.833-11.667 14.5-7.666 5.667-17.666 6.333-10 .667-19-5L480-229Z" />
    </svg>

  )
}